import { Action } from "redux";
import { isType } from "typescript-fsa";

import * as calendarSettingsActionsAddEditEventActions from "../actions/calendarSettingsActions_AddEditEvent";
import * as eventAddOrEditActions from "../actions/eventAddOrEditActions";

import { IAddOrEditEventResponse } from "../classes/event";

import { IAddEditEventState } from "../classes/state";

import { initialCalendarSettings_AddEditEvent } from "./initialState";

import { parse } from "./changeTimePeriod";

export default function eventAddOrEditReducer(state: IAddEditEventState = initialCalendarSettings_AddEditEvent, action: Action): IAddEditEventState {

  if (isType(action, calendarSettingsActionsAddEditEventActions.loadCalendarSettingsAddEditEvent_Success)) {
    const addEditText = action.payload.addEditText;
    const currentDateOnServer = action.payload.currentDateOnServer;
    const newState: IAddEditEventState = Object.assign({}, state);
    newState.addEditText = addEditText;
    newState.currentDateOnServer = parse(currentDateOnServer);
    return newState;
  }

  if (isType(action, eventAddOrEditActions.addOrEditEventError_Success)) {
    const eventResponse: IAddOrEditEventResponse = action.payload;
    const errorMessage = eventResponse.errorMessage.trim();

    const newState: IAddEditEventState = Object.assign({}, state);
    newState.errorMessage = errorMessage;

    return newState;
  }

  if (isType(action, eventAddOrEditActions.clearErrorMessage)) {
    const newState: IAddEditEventState = Object.assign({}, state);
    newState.errorMessage = "";
    return newState;
  }

  if (isType(action, eventAddOrEditActions.setStartDateAction)) {
    const newState: IAddEditEventState = Object.assign({}, state);
    newState.currentStartDate = action.payload as Date;
    return newState;
  }

  if (isType(action, eventAddOrEditActions.setDateOfFirstEventInRecurrenceAction)) {
    const newState: IAddEditEventState = Object.assign({}, state);
    newState.dateOfFirstEventInRecurrence = action.payload as Date;
    return newState;
  }

  return state;
};
